import { render, staticRenderFns } from "./tablelist.vue?vue&type=template&id=998d4aa4"
import script from "./tablelist.vue?vue&type=script&lang=js"
export * from "./tablelist.vue?vue&type=script&lang=js"
import style0 from "./tablelist.vue?vue&type=style&index=0&id=998d4aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports